import CarouselImg from '../components/Carousel/Carousel';
import 'bootstrap/dist/css/bootstrap.min.css';
import GamesList from '../components/GamesList/GamesList';

const Home = () => (
  <main>
    <CarouselImg />
    <GamesList />
  </main>
);

export default Home;
